import { useContext } from 'react';
import {
    Table, TableBody, TableCell, TableHead, TableRow, TableFooter, Typography, TablePagination, Grid, TableContainer
} from '@material-ui/core';
import { UsersContext } from '../UsersContext';
import { DeleteIconButton, EditIconButton } from 'components';
import { applicationContext } from 'helpers/services';
import { ReferenceData } from 'helpers/enums';


let Results = () => {
    let { userGroups, referenceData } = useContext(applicationContext);
    let service = useContext(UsersContext);

    return (
        <Grid container>
            <Grid item xs>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Email </TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>Groups</TableCell>
                        <TableCell>Supplier</TableCell>
                        <TableCell />
                    </TableRow>
                </TableHead>
                <TableBody>
                    {service.users.map((user, index) =>
                        <TableRow hover key={index}>
                            <TableCell>{user.email}</TableCell>
                            <TableCell>{user.firstName} {user.lastName}</TableCell>
                            <TableCell>{user.groups.map(x => userGroups.getValueByKey(x)).join(",")}</TableCell>
                            <TableCell>{referenceData.getByKey(ReferenceData.Supplier)?.values.getValueByKey(user.defaultSupplier)}</TableCell>
                            <TableCell align="right">
                                <EditIconButton link={`/admin/user/${user.id}`} />
                                <DeleteIconButton onClick={() => service.deleteUser(user.id)} stopPropagation />
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
                {service.users.length === 0 &&
                    <TableFooter>
                        <TableRow>
                            <TableCell colSpan={5}>
                                <Typography variant="subtitle2">No users found</Typography>
                            </TableCell>
                        </TableRow>
                    </TableFooter>
                }
            </Table>
            <TablePagination
                component="div"
                rowsPerPageOptions={[service.search.pageSize]}
                count={service.recordCount}
                rowsPerPage={service.search.pageSize}
                page={service.search.pageNr}
                backIconButtonProps={{ 'aria-label': 'Previous Page' }}
                nextIconButtonProps={{ 'aria-label': 'Next Page' }}
                onPageChange={(e, page) => service.changePage(page)}
                labelDisplayedRows={({ page }) =>
                    <span>Found {service.recordCount} users&nbsp;&middot;&nbsp;page {page + 1} of {Math.ceil(service.recordCount / service.search.pageSize)}</span>
                }
            />
            </Grid>
        </Grid>
    );
}

export default Results;